import Echo from 'laravel-echo';
import Vue from 'vue';
const Push = require('push.js');
const Pusher = require('pusher-js');

export default {
  methods: {
    initEcho () {
      if (this.$auth.check() && this.$echo === undefined) {
        // Pusher.logToConsole = process.env.NODE_ENV !== 'production';
		//
        // let echo = new Echo({
        //   broadcaster: 'pusher',
        //   key: this.$config.PUSHER_KEY,
        //   wsHost: this.$config.PUSHER_HOST,
        //   //wsPort: 443,
        //   disableStats: true,
        //   authEndpoint: this.$config.BROADCAST_URL,
        //   encrypted: true,
        //   auth: {
        //     headers: {
        //       'Authorization': 'Bearer ' + this.$auth.token()
        //     }
        //   }
        // });
		//
        // // Any notifications sent out will create a browser notification
        // echo.private('User.' + this.$auth.user().id).notification((e) => {
        //   this.browserNotify('DigidoLMS Notification', e.message, e.url);
        //   this.$store.dispatch('INCREMENT_NOTIFICATIONS');
        //   if (e.type === 'App\\Notifications\\SignoffRequiredAssessor') {
        //     this.$store.dispatch('LOAD_MY_SIGNOFF_FORMS', this);
        //   }
        // });
		//
        // Object.defineProperty(Vue.prototype, '$echo', {value: echo});
      }
    },
    browserNotify (title, body, url = null) {
      Push.create(title, {
        body: body,
        icon: '/img/icons/chrome/chrome-installprocess-128-128.png',
        timeout: 10000,
        onClick: () => {
          if (url) {
            this.$router.push(url);
          }
        }
      });
    }
  },
  mounted () {
    this.initEcho();
    Push.Permission.request();
  }
};
